import { z } from 'zod/v4';
import { TemplateSchema } from './attachment-template.js';

export const DefinedRuleDocumentSchema = z.object({
  facilityProcessId: z.string(),
  documentType: z.string(),
  title: z.string().nullable(),
  documentClass: z.enum(['TRANSACTIONAL', 'COMPANY']).nullable(),
  isAppliedToAllCountries: z.boolean(),
  isMandatory: z.boolean(),
  countryCodes: z.array(z.string()),
  syncedDocument: z
    .object({
      documents: z.array(
        z.object({
          id: z.string(),
          name: z.string(),
        }),
      ),
      otherVersionsAvailable: z.number().int(),
    })
    .nullable()
    .optional(),
});
export type DefinedRuleDocumentType = z.infer<typeof DefinedRuleDocumentSchema>;

export const TemplateWithDefinedRulesSchema = TemplateSchema.extend({
  rules: z.array(DefinedRuleDocumentSchema),
});
export type TemplateWithDefinedRulesType = z.infer<
  typeof TemplateWithDefinedRulesSchema
>;

const AttachmentSchema = z.object({
  id: z.string(),
  tracingTransactionId: z.string(),
  assetId: z.string().nullable(),
  assetType: z.string().nullable(),
  transactionType: z.string().nullable(),
  name: z.string().nullable(),
  reference: z.string().nullable(),
  description: z.string().nullable(),
  type: z.string().nullable(),
  fileId: z.string().nullable(),
  fileName: z.string().nullable(),
  fileType: z.string().nullable(),
  fileContentType: z.string().nullable(),
  fileUrl: z.string().nullable(),
});

export const TemplateWithDefinedRulesAndOrdersSchema =
  TemplateWithDefinedRulesSchema.extend({
    orders: z.array(
      z.object({
        id: z.string(),
        tracingAttachmentTemplateId: z.string(),
        originTracingNodeId: z.string(),
        destinationTracingNodeId: z.string(),
        traceType: z.string(),
        attachments: z.array(AttachmentSchema),
      }),
    ),
  });
export type TemplateWithDefinedRulesAndOrdersType = z.infer<
  typeof TemplateWithDefinedRulesAndOrdersSchema
>;
